export const SITE_ORIGIN = "https://darkskies.earthboundmartian.com";
export const SITE_NAME = "Darkskies";
export const SITE_TAGLINE = "Find dark skies you can actually stay under.";
export const SITE_DESCRIPTION =
  "A free map of vehicle-friendly dark-sky locations, satellite night lights, and upcoming new-moon windows.";
export const ORG_ORIGIN = "https://earthboundmartian.com";
export const ORG_NAME = "Earthbound Martian, LLC";
export const CONTACT_EMAIL = "darkskies@earthboundmartian.com";
